var React = require('react');

function Arrows (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"arrowOne","d":"M15 22L53.8 64L15 106","stroke":"white","strokeWidth":"15","strokeLinecap":"round","key":0}),React.createElement("path",{"id":"arrowTwo","d":"M73.2002 22L112 64L73.2002 106","stroke":"white","strokeWidth":"15","strokeLinecap":"round","key":1})]);
}

Arrows.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = Arrows;

Arrows.default = Arrows;
